import { Link } from "react-router-dom";
import "./Billing.css";

export default function BillingCancel() {
  return (
    <main className="billing-shell billing-state-page">
      <div className="billing-state-card">
        <div className="billing-state-icon billing-state-icon--cancel">×</div>
        <div className="billing-brand-kicker">PLAYSWITHGURU</div>

        <h1>Checkout cancelled</h1>

        <p className="billing-state-lead">
          No charge was made. Your existing access has not been changed.
        </p>

        <div className="billing-state-actions">
          <Link
            to="/pricing"
            className="billing-cta billing-cta--gold billing-link-button"
          >
            Return to Pricing
          </Link>

          <Link
            to="/"
            className="billing-cta billing-cta--secondary billing-link-button"
          >
            Back to PlaysWithGuru
          </Link>
        </div>
      </div>
    </main>
  );
}
